import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import { BackLink } from '../../../components/idsk';
import { usePageTitle } from '../../../layout/usePageTitle';
import { ControlPalette } from './ControlPalette';
import type { PaletteItem, PaletteTarget } from './palette';

/** Page "Pridať prvok formulára": the controls palette on its own (target from `?skupina=`). */
export function PalettePage({ backTo, titleParts, targets, itemPath }: { backTo: string; titleParts: string[]; targets: PaletteTarget[]; itemPath: (item: PaletteItem, parentKey: string | null) => string }) {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const requested = params.get('skupina');
  const [target, setTarget] = useState<string | null>(targets.some((x) => x.key === requested) ? requested : null);
  const title = t('builder.palette.pageTitle');
  usePageTitle([title, ...titleParts]);
  return (
    <>
      <BackLink to={backTo} />
      <div className="govuk-grid-row">
        <div className="govuk-grid-column-two-thirds">
          <ControlPalette
            targets={targets}
            target={target}
            onTargetChange={setTarget}
            itemPath={itemPath}
            heading={
              <h1 className="govuk-heading-l" id="palette-heading" tabIndex={-1}>
                {title}
              </h1>
            }
          />
        </div>
      </div>
    </>
  );
}
